import axios from "../axios";

const initializeTransaction = (data) => {
  return axios.post("/paystack/transaction", data);
};

const verifyTransaction = (reference, data) => {
  return axios.post(`/paystack/transaction/verify/${reference}`, data);
};

const chargeSavedCard = (data) => {
  return axios.post(`/paystack/transaction/charge_authorization`, data);
};

const paystackService = {
  initializeTransaction,
  verifyTransaction,
  chargeSavedCard,
};

export default paystackService;
